import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type ModbustListDetails } from '../services/getModbusParamterService'

export interface SchdulerListDataState {
  isLoading: boolean
  loadingError: string | undefined
  ModBusParameterListData: ModbustListDetails[] | undefined
  httpStatus: number | undefined
}

// Initial state of the slice
const initialState: SchdulerListDataState = {
  isLoading: false,
  loadingError: undefined,
  ModBusParameterListData: undefined,
  httpStatus: undefined
}

// Slice to return from action
export const ModbusListingDataState = createSlice({
  name: 'ModBusParameterListData',
  initialState,
  reducers: {
    ModBusListDataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: undefined,
        ModBusParameterListData: undefined,
        httpStatus: 0
      }
    },
    ModBusListDataUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        isLoading: false,
        loadingError: undefined,
        ModBusParameterListData: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    ModBusListDataErrorAction: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload,
        httpStatus: action.payload.httpStatus,
        ModBusParameterListData: undefined
      }
    }
  }
})

// Actions to export
export const {
  ModBusListDataLoadingAction,
  ModBusListDataUpdateAction,
  ModBusListDataErrorAction
} = ModbusListingDataState.actions

export default ModbusListingDataState.reducer
